import React, { useState } from 'react'
import {
    Button,
    Table,
    Tr,
    Flex,
    PageWrapper,
    PageFooter,
    Th,
    H1WithBack,
    HeadlineFlex,
} from '../../../styling/GlobalStyles'
import { useSelector } from 'react-redux'
import { Pagination } from 'components/Pagination/Pagination'
import { RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { clearProvisioningRecords, getProvisioningRecords } from 'features/food/foodSlice'
import { NavBar } from 'components/NavBar/NavBar'
import { useNavigate } from 'react-router-dom'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { GenerateFoodRecordsModal } from './GenerateFoodRecordsModal'

export const ProvisioningRecords = () => {
    const { provisioningRecords } = useSelector((store: RootState) => store.food)
    const [params, setParams] = useState<any>(getParams({ location, limit: 30, ap: { date: new Date(), groupBy: 'supplier' } }))
    const [modal, setModal] = useState(false)
    const navigate = useNavigate()
    useQueryPagination({ fetchFunctions: [getProvisioningRecords], cleanUpFunctions: [clearProvisioningRecords], params })

    const filterOptions = [
        { label: 'Supplier', value: 'supplier' },
        { label: 'Meal Type', value: 'mealType' },
    ]

    return (
        <>
            <NavBar defaultValue={params.q} input placeholder='Search Records...' setParams={setParams} limit={30} />
            <PageWrapper>
                <HeadlineFlex between center mb='16' >
                    <H1WithBack arrow title='Provisioning Records' />
                    <Flex gap='1rem' alignEnd >
                        <HeadlineFlex gap='1rem' >
                            <Flex gap='1rem' >
                                <CalendarInput nomarg width='200px' labelText='Date' onChange={date => setParams(prev => ({ ...prev, date }))} defaultValue={params.date} />
                                <HonestSelectInput noX width='200px' defaultValue={params.groupBy} nomarg labelText='Group By' options={filterOptions} onChange={(v: ISelectValue) => setParams(prev => ({ ...prev, groupBy: v.value }))} />
                            </Flex>
                            <Flex gap='1rem' >
                                <Button width='200px' orange onClick={() => navigate('standby')} >Stand By Provisioning</Button>
                                <Button width='200px' orange onClick={() => navigate('ad-hoc')} >Ad Hoc Provisioning</Button>
                                <Button width='200px' orange onClick={() => setModal(true)} >Generate Records</Button>
                            </Flex>
                        </HeadlineFlex>

                    </Flex>
                </HeadlineFlex>
                {!provisioningRecords?.data?.length ? (
                    <NoItems title='Records' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='20%' noTooltip text='SUPPLIER' />
                            <Td w='80%' noTooltip text='MEAL TYPES' />
                        </Th>
                        {
                            provisioningRecords.data.map((item, k) => {
                                return (
                                    <Tr key={k}>
                                        <Td w='16%' text={item.foodSupplier?.name || '/'} />
                                        <Td w='16%' text={item.mealTypes.map(mt => mt.mealType?.name).join(', ')} />

                                    </Tr>
                                )
                            })}
                    </Table>
                )}
                {modal && <GenerateFoodRecordsModal closeModal={() => setModal(false)} />}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(provisioningRecords.totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
